import React, { Component } from "react";
import { Form, Container, Row, Col, Button, } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./SleepEntry.css";
import { API } from "aws-amplify";
import { FiArrowLeft } from "react-icons/fi";
import duration from "../duration";

export default class SleepEntry extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
      sleepEnd: "",
      sleepStart: "",
      sleepRating: "",
      timesAwake: "",
      sleepDate: "",
      sleepNote: "",
      sleepDuration: "",
    };
  }

  validateForm() {
    let startForm = this.state.sleepStart.length !== "";
    let endForm = this.state.sleepEnd.length !== "";
    let ratingForm = !isNaN(this.state.sleepRating);
    let awakeForm = !isNaN(this.state.timesAwake);
    let dateForm = this.state.sleepDate !== "";
    let result = (startForm && endForm && ratingForm && awakeForm && dateForm) === true;
    return result;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.sleepStart !== "check" && this.state.sleepEnd !== "check") {
      this.sleepDuration = duration.calculateDuration(this.state.sleepStart, this.state.sleepEnd); 
    }
    try {
      await this.createSleepEntry({
        sleepStart: this.state.sleepStart,
        sleepEnd: this.state.sleepEnd,
        sleepRating: this.state.sleepRating,
        timesAwake: this.state.timesAwake,
        sleepDate: this.state.sleepDate,
        sleepNote: this.state.sleepNote || " ",
        sleepDuration: this.sleepDuration,
      });
      this.props.history.push(`${process.env.PUBLIC_URL}/`);
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }

  createSleepEntry(sleepEntry) {
    return API.post("sleep", "/sleep/", {
      body: sleepEntry
    });
  }

  render() {
    return (
      <div>
        <Button className="backBtn" onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/`)}><FiArrowLeft></FiArrowLeft></Button>
        <div className="SleepEntry">
          <form onSubmit={this.handleSubmit}>
            <Container>
              <Row>
                <Col className="sleepStartCol">
                  <Form.Group controlId="sleepStart">
                    <Form.Label>Sleep Start </Form.Label>
                    <Form.Control
                      onChange={this.handleChange}
                      value={this.state.sleepStart}
                      type="time"
                    />
                  </Form.Group>
                </Col>
                <div className="divider"></div>
                <Col className="sleepEndCol">
                  <Form.Group controlId="sleepEnd">
                    <Form.Label>Sleep End </Form.Label>
                    <Form.Control
                      onChange={this.handleChange}
                      value={this.state.sleepEnd}
                      type="time"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Container>
            <Form.Group controlId="sleepRating">
              <Form.Label>Sleep Rating </Form.Label>
              <Form.Control
                onChange={this.handleChange}
                placeholder="How would you rate your sleep? (1-10)"
                value={this.state.sleepRating}
                min="1"
                max="10"
                type="number"
              />
            </Form.Group>
            <Form.Group controlId="timesAwake">
              <Form.Label>Times Awake </Form.Label>
              <Form.Control
                onChange={this.handleChange}
                min="0"
                placeholder="How many times did you wake up?"
                value={this.state.timesAwake}
                type="number"
              />
            </Form.Group>
            <Form.Group controlId="sleepDate">
              <Form.Label>Sleep Date </Form.Label>
              <Form.Control
                onChange={this.handleChange}
                value={this.state.sleepDate}
                type="date"
              />
            </Form.Group>
            <Form.Group controlId="sleepNote">
              <Form.Label>Notes </Form.Label>
              <Form.Control
                onChange={this.handleChange}
                value={this.state.sleepNote}
                as="textarea"
                rows="3"
              />
            </Form.Group>
            <LoaderButton
              block
              disabled={!this.validateForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text="Create"
              loadingText="Creating…"
              className="createBtn entryBtn"
            />
          </form>
        </div>
      </div>
    );
  }
}
